// removed by extract-text-webpack-plugin
module.exports = {"Container":"App__Container__2Y284"};